import { cn } from '@/lib/utils';
import styles from './decorative-lines.module.scss';

type DecorativeLinesProps = {
  showDots?: boolean;
  showLines?: boolean;
  variant?: 'light' | 'dark';
};

export const DecorativeLines = ({
  showDots = false,
  showLines = false,
  variant = 'light',
}: DecorativeLinesProps) => {
  if (!showDots && !showLines) return null;
  return (
    <>
      {showDots && (
        <div
          className={cn(styles.dots_left, variant === 'dark' && styles['dots--dark'])}
          aria-hidden="true"
        />
      )}
      {showDots && (
        <div
          className={cn(styles.dots_right, variant === 'dark' && styles['dots--dark'])}
          aria-hidden="true"
        />
      )}
      {showLines && (
        <div
          className={cn(styles.line_left, variant === 'dark' && styles['line--dark'])}
          aria-hidden="true"
        />
      )}
      {showLines && (
        <div
          className={cn(styles.line_right, variant === 'dark' && styles['line--dark'])}
          aria-hidden="true"
        />
      )}
    </>
  );
};
